import { Controller } from "react-hook-form";
import { usePreOS } from "./useSearchPreOS";

//components
import { BreadCrumbs, Button } from "@atoms";
import { Input, InputSearch, Select, Attach } from "@molecules";
import { zafClient } from "@service/zendesk";
import { getAddressByCep } from "@service/post";
import { popupError } from "@service/zendesk";

export const PreOs = () => {
  const helper = usePreOS();

  return (
    <form onSubmit={helper.handleSubmit(helper.onSubmit, helper.onError)} className="w-full">
      <BreadCrumbs items={["Pré-OS", "Criação"]} />
      <h3 className="text-[#2F3941]">Criar Pré-OS</h3>

      {helper.loading ? (
        <p>carregando...</p>
      ) : (
        <div className="w-full h-[55vh] overflow-x-hidden overflow-y-auto mb-[20px]">
          <div className="w-[97%] ml-[5px] mb-[5px] flex flex-col gap-[12px]">
            <Controller
              name="osPrincipal"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="OS principal*"
                  placeholder="Informe ticket problem"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="assunto"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="Assunto*"
                  placeholder="Informe o assunto do incidente"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="descricao"
              control={helper.control}
              render={({ field }) => (
                <textarea
                  className="w-[93%] h-[150px] p-[15px] rounded-[4px] resize-none outline-none border-[#D8DCDE] text-[16  px]"
                  placeholder="Descrição*"
                  {...field}
                  onChangeCapture={field.onChange}
                />
              )}
            />

            <Controller
              name="codigoPosto"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="Código do posto"
                  placeholder="Código posto"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="referenciaProduto"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="Código do produto"
                  placeholder="Código produto"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="descricaoProduto"
              control={helper.control}
              render={({ field }) => (
                <InputSearch
                  mode="product"
                  objectTypeKey="produto"
                  label="Descrição do produto*"
                  placeholder="Digite nome/código"
                  minChars={2}
                  debounceMs={300}
                  value={field.value || helper.watch("descricaoProduto")}
                  onValueChange={field.onChange}
                  onSelect={async (item) => {
                    if (item.kind !== "product") return;
                    await zafClient.set("ticket.customField:custom_field_38546069276180", item.id);
                    field.onChange(item.name ?? "");
                  }}
                />
              )}
            />

            <Controller
              name="numeroSerie"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="Número de série*"
                  placeholder="Informe o valor"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="statusSolicitacao"
              control={helper.control}
              defaultValue="aguardando_os" // <-- valor default aqui
              render={({ field }) => (
                <Select
                  label="Status da solicitação*"
                  placeholder="Status da solicitação"
                  options={[
                    { value: "aguardando_os", label: "Aguardando OS" },
                    { value: "gerado_os", label: "Gerado OS" },
                    { value: "erro", label: "Erro" },
                  ]}
                  value={field.value}
                  onChange={(_, val) => field.onChange(val)}
                />
              )}
            />

            <Controller
              name="nomeConsumidor"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="Nome do consumidor*"
                  placeholder="Inserir o nome"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="emailConsumidor"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="E-mail do consumidor*"
                  placeholder="Inserir o nome"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="cep"
              control={helper.control}
              render={({ field }) => (
                <div>
                  <Input
                    label="CEP*"
                    placeholder="Inserir o CEP"
                    {...field}
                    disabled={helper.cepLoading}
                    onValueChange={async (value) => {
                      field.onChange(value);
                      const cleanedCep = value.replace(/\D/g, "");
                      if (cleanedCep.length === 8) {
                        helper.setCepLoading(true);
                        try {
                          const address = await getAddressByCep(cleanedCep);
                          if (!address.erro) {
                            helper.setValue("endereco_2", address.logradouro || "");
                            helper.setValue("bairro", address.bairro || "");
                            helper.setValue("cidade", address.localidade || "");
                            helper.setValue("estado", address.uf || "");
                          }
                        } catch {
                          popupError("Erro ao buscar CEP", false);
                        } finally {
                          helper.setCepLoading(false);
                        }
                      }
                    }}
                  />
                  {helper.cepLoading && (
                    <div className="flex items-center gap-2 mt-1">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                      <small className="text-sm text-gray-500">Buscando CEP...</small>
                    </div>
                  )}
                </div>
              )}
            />

            <Controller
              name="endereco_2"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="Endereço*"
                  placeholder="Inserir o endereço"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="numero"
              control={helper.control}
              defaultValue="" // garante que o valor inicial é string
              render={({ field }) => (
                <Input
                  label="Número*"
                  placeholder="Inserir o número"
                  value={field.value || ""} // sempre string
                  onValueChange={(val) => field.onChange(val)} // val é string
                />
              )}
            />

            <Controller
              name="bairro"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="Bairro*"
                  placeholder="Inserir o bairro"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="cidade"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="Cidade*"
                  placeholder="Inserir a cidade"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="estado"
              control={helper.control}
              render={({ field }) => (
                <Select
                  label="Estado*"
                  placeholder="Selecione o estado"
                  options={[
                    { value: "AC", label: "Acre" },
                    { value: "AL", label: "Alagoas" },
                    { value: "AP", label: "Amapá" },
                    { value: "AM", label: "Amazonas" },
                    { value: "BA", label: "Bahia" },
                    { value: "CE", label: "Ceará" },
                    { value: "DF", label: "Distrito Federal" },
                    { value: "ES", label: "Espírito Santo" },
                    { value: "GO", label: "Goiás" },
                    { value: "MA", label: "Maranhão" },
                    { value: "MT", label: "Mato Grosso" },
                    { value: "MS", label: "Mato Grosso do Sul" },
                    { value: "MG", label: "Minas Gerais" },
                    { value: "PA", label: "Pará" },
                    { value: "PB", label: "Paraíba" },
                    { value: "PR", label: "Paraná" },
                    { value: "PE", label: "Pernambuco" },
                    { value: "PI", label: "Piauí" },
                    { value: "RJ", label: "Rio de Janeiro" },
                    { value: "RN", label: "Rio Grande do Norte" },
                    { value: "RS", label: "Rio Grande do Sul" },
                    { value: "RO", label: "Rondônia" },
                    { value: "RR", label: "Roraima" },
                    { value: "SC", label: "Santa Catarina" },
                    { value: "SP", label: "São Paulo" },
                    { value: "SE", label: "Sergipe" },
                    { value: "TO", label: "Tocantins" },
                  ]}
                  value={field.value}
                  onChange={(_, val) => field.onChange(val)}
                />
              )}
            />

            <Controller
              name="telefoneConsumidor"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="Telefone do consumidor*"
                  placeholder="Inserir o telefone"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="notaFiscal"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="Nota fiscal*"
                  placeholder="Inserir a nota fiscal"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="anexos"
              control={helper.control}
              render={({ field }) => (
                <Attach
                  label="Anexe uma imagem da nota fiscal"
                  accept="image/*"
                  onFilesChange={(files: File[]) => field.onChange(files)}
                />
              )}
            />

            <Controller
              name="dataCompra"
              control={helper.control}
              render={({ field }) => (
                <Input
                  label="Data da compra*"
                  type="date"
                  {...field}
                  onValueChange={field.onChange}
                />
              )}
            />

            <Controller
              name="defeitoReclamado"
              control={helper.control}
              render={({ field }) => (
                <Input label="Defeito reclamado*" {...field} onValueChange={field.onChange} />
              )}
            />

            <Controller
              name="aparenciaProduto"
              control={helper.control}
              render={({ field }) => (
                <Input label="Aparência do produto" {...field} onValueChange={field.onChange} />
              )}
            />
          </div>
        </div>
      )}

      <div className="w-full border-t border-[#D8DCDE] flex flex-col gap-[20px]">
        <Button type="submit">Criar Pré-OS</Button>
        <Button onClick={helper.backToHome}>Voltar</Button>
      </div>
    </form>
  );
};
